import React from 'react';
import {Typography, Box} from '@mui/material';
import ExtractionTablePreview from '../PdfViewer/ViewerContainer/ExtractionTablePreview';
import {buildExtractionTableDataWithGroups} from '../PdfViewer/ViewerContainer/ViewerContainer';
import {useTranslation} from "react-i18next";

export default function ToolReviewStep({selectedAnnotations, groupMeta}) {
    const {t} = useTranslation();

    // Exclude table annotations from the review preview
    const reviewAnnotations = Array.isArray(selectedAnnotations)
        ? selectedAnnotations.filter(a => a?.type !== 'table')
        : [];

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                overflow: 'auto',
                width: '100%',
            }}
        >
            <Typography
                variant="h5"
                gutterBottom
                align="center"
                sx={{mt: 10, mb: 5}}
            >
                {t("steps.review_save")}
            </Typography>
            <Typography
                variant="body2"
                gutterBottom
                align="center"
                sx={{mt: 0, mb: 5}}
            >
                {t("review_save_description")}
            </Typography>
            <ExtractionTablePreview
                tableData={buildExtractionTableDataWithGroups(reviewAnnotations, groupMeta)}
            />
        </Box>
    );
}
